import { allyAhead, assertLeaderMayAct, attackUnit, blockedByCorner, runRound } from '../round.ts';
import { InvalidCommand, hasStatus } from '../state.ts';
import type { CommandHandler } from './types.ts';

/**
 * The leader makes a basic attack on the tile it faces, then the round runs.
 * Refused ('cannot attack around a corner') when a standing unit stands on the
 * diagonal tile it faces but a wall blocks the corner (the corner rule of a
 * diagonal step), and ('cannot attack an ally') when a standing ally stands
 * there, unless the leader is confused; confusion may then send the attack in
 * a random direction (round.ts `attackUnit`). Hitting or missing a unit of
 * the other side gives `spPerBasicAttack` SP; attacking air or an ally gives
 * none.
 */
export type AttackCommand = {
  readonly type: 'attack';
};

export const attack: CommandHandler<AttackCommand> = (ctx, state) => {
  const leader = assertLeaderMayAct(state, 'other');
  if (!hasStatus(leader, 'confusion')) {
    if (blockedByCorner(state, leader.id)) throw new InvalidCommand('attack_around_corner', 'cannot attack around a corner');
    if (allyAhead(state, leader.id) !== null) throw new InvalidCommand('attack_ally', 'cannot attack an ally');
  }
  return runRound(ctx, state, (s) => attackUnit(ctx, s, leader.id, leader.facing), 'busy');
};
